export default __webpack_public_path__ + "static/star-terminal-066c57c628fc79b65b21c99f5e562589.png";